module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.bd39f304.svg";